export const months = Array.from({ length: 12 }, (_, i) => ({
  label: (i + 1).toString().padStart(1, '0') + '月',
  value: (i + 1).toString().padStart(2, '0'),
}));

export const dates = Array.from({ length: 31 }, (_, i) => ({
  label: (i + 1).toString().padStart(1, '0') + '日',
  value: (i + 1).toString().padStart(2, '0'),
}));
